import * as React from 'react'

import InnerLink, { InnerLinkType } from '../../atoms/InnerLink/InnerLink'
import * as styles from './CompletePayment.css'

const CompletePayment: React.FunctionComponent = () => {
  return (
    <div className={styles.container}>
      <p className={styles.bold}>ご購入いただきありがとうございます。</p>
      <p className={styles.passage}>さっそくennoshitaを使ってクイズを作成してみよう</p>
      <div className={styles.quizLink}>
        <InnerLink to="/" type={InnerLinkType.RED}>
          <p className={styles.quizLinkText}>クイズを作成</p>
        </InnerLink>
      </div>
    </div>
  )
}

export default CompletePayment
